import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer style={{
      background: '#f8f9fa',
      borderTop: '1px solid #e1e5e9',
      padding: '2rem 0',
      marginTop: 'auto'
    }}>
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '0 2rem',
        textAlign: 'center'
      }}>
        <p style={{ color: '#666', margin: 0 }}>
          © 2025 CyberMed.ai - Medical Device Cybersecurity Guide
        </p>
      </div>
    </footer>
  );
};

export default Footer;
